<template>
	<div class="link-document" :class="{'link-document-show-nav':showNav,'link-document-printing':p_isPrint}" @click.catch="onClickCatch">
		<div class="link-document-item-wrapper" ref="wrapper">
			<link-document-item v-for="(item,index) in blocks"
								ref="items"
								:key="index"
								:data="item"

								@debug="debug(item)"
								@browse="browse(item)"
			/>
		</div>

		<div class="link-document-nav">
			<div class="link-document-nav-list">
				<div class="link-document-nav-item" v-for="(item,index) in navs" :key="index" @click="pl_clickNavItem(item)">
					<span>{{!!item.setting ? item.setting.title : '?'}}</span>
					<div class="link-document-nav-item-tag">
						<div class="link-document-nav-item-tag-inner"></div>
					</div>
				</div>
			</div>
			<div class="link-document-nav-operator">
				<div class="link-document-nav-operator-item" @click="showNav = !showNav" v-link-tooltip="'展开/收起 当前文档'">
					<link-icon icon="icon-menu"/>
				</div>
				<div class="link-document-nav-operator-item" @click="pl_printPage" v-link-tooltip="'打印当前文档，打印的请钩上更多设置中的【背景图形】'">
					<link-icon icon="icon-iconset0118"/>
				</div>
				<div class="link-document-nav-operator-item" @click="pl_moveTop" v-link-tooltip="'回到顶部'">
					<link-icon icon="icon-scroll-top"/>
				</div>
				<div class="link-document-nav-operator-item" @click="pl_moveBottom" v-link-tooltip="'回到底部'">
					<link-icon icon="icon-scroll-bottom"/>
				</div>
			</div>
		</div>

		<link-dialog v-model="showBrowseDialog" height="75vh" width="50vw" :title="browseData.setting.title" v-if="!!browseData" noHeader noPadding :disabledHideOnClickShadow="false">
			<link-document-item-demo-code :data="browseData"/>
		</link-dialog>

	</div>
</template>

<script>
	import LinkDocumentItem from "./link-document-item";
	import LinkDocumentItemDemoCode from "./link-document-item-demo-code";

	export default {
		name: "link-document",
		components: {LinkDocumentItemDemoCode, LinkDocumentItem},
		props: {
			value: {},
			nav: {},
		},
		watch: {
			value: {
				immediate: true,
				handler(val) {
					this.blocks = this.getBlocksByValue(val)
				},
			}
		},
		data() {
			return {
				blocks: [],
				showNav: false,
				showBrowseDialog: false,
				browseData: null,
				p_isPrint: false,
			}
		},
		computed: {
			navs() {
				if (!this.blocks) return []
				return this.blocks.filter(item => !!item.demo && !!item.setting.nav && !!item.setting.title)
			},
		},
		methods: {
			/*---------------------------------------关于解析markdown文本-------------------------------------------*/
			/**
			 * 解析value属性markdown文本为block数组
			 * @author  韦胜健
			 * @date    2019/5/30 15:39
			 */
			parseValue(value) {
				if (!value) return []
				let markdownText = value
				const blocks = []
				const tag = 'demo'
				const startTag = `<${tag}>`, endTag = `</${tag}>`
				const splitTag = '?????'

				let startIndex = markdownText.indexOf(startTag)
				let endIndex = markdownText.indexOf(endTag, startIndex + startTag.length) + endTag.length
				while (startIndex > -1) {
					const blockText = markdownText.substring(startIndex, endIndex)
					blocks.push(blockText.replace(startTag, '').replace(endTag, ''))
					markdownText = markdownText.replace(blockText, splitTag)

					startIndex = markdownText.indexOf(startTag)
					endIndex = markdownText.indexOf(endTag, startIndex + startTag.length) + endTag.length
				}

				let texts = markdownText.split(splitTag)

				const ret = blocks.reduce((ret, demo, index) => {
					ret.push({
						content: texts[index],
						demo: false
					})
					ret.push({
						content: blocks[index],
						demo: true
					})
					return ret
				}, [])

				ret.push({
					demo: false,
					content: texts[texts.length - 1]
				})

				return ret
				/*return ret.map(item => this.p_decodeBlock(item)).filter(item => !!item.isBlock || item.md.trim() !== '')*/
			},

			/**
			 * 从文本总解析start开头，end结尾的内容文本
			 * @author  韦胜健
			 * @date    2019/5/30 16:22
			 */
			parseContentByTag(text, {start, end}) {
				text = text.trim()
				let startIndex = text.indexOf(start), endIndex, ret
				if (startIndex > -1) {
					endIndex = text.indexOf(end, startIndex + start.length) + end.length
					ret = text.substring(startIndex, endIndex)
					text = text.replace(ret, '')
					ret = ret.replace(start, '').replace(end, '')
				}
				return {
					ret,
					text,
				}
			},

			/**
			 * 解析block文本，转化为具体信息
			 * @author  韦胜健
			 * @date    2019/5/30 16:14
			 */
			parseBlock({content, demo}) {
				if (!demo) {
					return {
						text: content,
						demo,
						type: 'text',
					}
				}
				let result = {}
				let types = [
					{key: "html", start: '```html', end: '```'},
					{key: "js", start: '```js', end: '```'},
					{key: "css", start: '```css', end: '```'},
				]
				let {ret: settingText, text} = this.parseContentByTag(content, {start: '<setting>', end: '</setting>'})
				content = text
				if (!!settingText) {
					result.setting = settingText.split('\n').reduce((r, i) => {
						i = i.trim()
						if (!i) return r
						const separatorIndex = i.indexOf(":")
						r[i.substring(0, separatorIndex)] = i.substring(separatorIndex + 1)
						return r
					}, {})
				} else {
					result.setting = {}
				}
				if (!result.setting.collect && !!demo) result.setting.collect = 'desc'
				result.setting.collect = result.setting.collect.split(',')
				result.setting.collect.forEach((tag) => {
					types.push({
						key: tag,
						start: `<${tag}>`,
						end: `</${tag}>`,
					})
				})

				/*解析types中的标签*/
				result = Object.assign(result, types.reduce((r, {key, start, end}) => {
					let {ret, text} = this.parseContentByTag(content, {start, end})
					content = text
					result[key] = !!ret ? ret.trim() : ret
					return result
				}, {}))
				result.text = content
				result.demo = demo

				if (result.demo) {
					result.setting.nav = result.setting.nav !== false
					result.type = !!result.setting.img ? 'img' : !!result.setting.slot ? 'slot' : !!result.setting.table ? 'table' : 'demo'
				}

				return result

			},

			/**
			 * 解析markdown文本
			 * @author  韦胜健
			 * @date    2019/5/30 17:06
			 */
			getBlocksByValue(val) {
				const blocks = this.parseValue(val)
				return blocks.map(i => this.parseBlock(i)).filter(it => it.demo || (!!it.text && !!it.text.trim()))
			},


			/*---------------------------------------代码相关操作-------------------------------------------*/
			debug(item) {
				this.$nav.openTab({
					id: this.$lv.$utils.uuid(),
					title: item.setting.title,
					path: 'debug',
					param: item,
				})
			},
			async browse(item) {
				this.browseData = item
				await this.$lv.nextTick()
				this.showBrowseDialog = true
			},


			/*---------------------------------------导航相关-------------------------------------------*/
			pl_clickNavItem(item) {
				for (let i = 0; i < this.$refs.items.length; i++) {
					const it = this.$refs.items[i];
					if (it.data === item) {
						this.$refs.wrapper.scrollTop = it.$el.offsetTop
						return
					}
				}
			},
			pl_moveTop() {
				this.$refs.wrapper.scrollTop = 0
			},
			pl_moveBottom() {
				this.$refs.wrapper.scrollTop = this.$refs.wrapper.scrollHeight
			},
			pl_printPage() {
				window.print()
			},
			onClickCatch(e) {
				if (e.target.tagName !== 'A') return
				const target = e.target
				let href = target.getAttribute('href')

				if (!href.startsWith('#')) return;
				let tableOfContents = this.$el.querySelector('.table-of-contents')
				if (!tableOfContents || !tableOfContents.contains(target)) return;
				let text = target.innerHTML

				let list = this.$el.querySelectorAll('h1,h2,h3,h4') || []
				for (let i = 0; i < list.length; i++) {
					const item = list[i];
					if (item.innerHTML === text) {
						this.$refs.wrapper.scrollTop = item.offsetTop
						return;
					}
				}
			},
		},
	}
</script>

<style lang="scss">
	@include themeify {
		.link-document {
			position: relative;
			color: pl-var(color-normal-content);
			height: 100%;

			$nav-width: 150px;

			.link-document-item-wrapper {
				padding: 16px 16px 16px 16px;
				box-sizing: border-box;
				height: 100%;
				overflow-y: auto;
				overflow-x: hidden;
			}

			&.link-document-printing {
				height: initial;

				.link-document-nav {
					display: none;
				}
			}

			.link-document-nav {
				position: absolute;
				width: $nav-width;
				top: 16px;
				bottom: 16px;
				right: 20px;
				font-size: 12px;
				pointer-events: none;

				.link-document-nav-list {
					position: relative;
					display: none;

					&:after {
						position: absolute;
						left: -1em;
						content: '';
						top: 0;
						bottom: 0;
						border-left: 1px dashed pl-var(color-primary);
						opacity: 0.25;
					}

					.link-document-nav-item {
						font-size: 12px;
						color: #333;
						cursor: pointer;
						width: 100%;
						text-overflow: ellipsis;
						white-space: nowrap;
						height: 36px;
						line-height: 36px;
						position: relative;
						pointer-events: auto;

						span {
							display: inline-block;
							width: 100%;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}

						&:hover {
							color: pl-var(color-primary-deep);
							text-decoration: underline;
						}

						.link-document-nav-item-tag {
							position: absolute;
							left: -16px;
							top: 13px;
							height: 9px;
							width: 9px;
							background-color: rgba(pl-var(color-primary), 0.25);
							border-radius: 9px;
							display: flex;
							align-items: center;
							justify-content: center;

							.link-document-nav-item-tag-inner {
								height: 3px;
								width: 3px;
								border-radius: 3px;
								background-color: pl-var(color-primary);
							}
						}
					}
				}

				.link-document-nav-operator {
					position: absolute;
					right: 12px;
					top: 0;
					bottom: 0;
					display: flex;
					align-items: center;
					justify-content: flex-end;
					flex-direction: column;

					.link-document-nav-operator-item {
						width: 40px;
						height: 40px;
						border-radius: 40px;
						outline: none;
						box-shadow: 0 0 18px 0 #dedfea;
						background-color: white;
						text-align: center;
						line-height: 40px;
						color: pl-var(color-primary);
						font-size: 18px;
						cursor: pointer;
						margin-top: 16px;
						pointer-events: auto;

						&:active {
							background-color: rgba(pl-var(color-primary), 0.25);
						}
					}
				}
			}

			&.link-document-show-nav {
				.link-document-nav-list {
					display: block;
				}

				.link-document-item-wrapper {
					padding-right: $nav-width+25px;
				}
			}
		}

		.link-document-item-demo-instance {
			padding: 16px;
			box-sizing: border-box;
		}
	}

	@media print {
		.link-document-nav {
			display: none !important;
		}
		.link-document, .link-document-item-wrapper {
			height: initial !important;
		}
		.pl-navigator-main-body {
			margin: 0 !important;
		}
	}
</style>
